import { render, staticRenderFns } from "./FamilyWrapper.vue?vue&type=template&id=5086aa9b&"
import script from "./FamilyWrapper.vue?vue&type=script&lang=ts&"
export * from "./FamilyWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports